import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { ReportGetSingleById, ReportGetSingleByIdResponse } from '../../api/dtos';

const getData = (response?: SWRResponse<ReportGetSingleByIdResponse, ReportGetSingleByIdResponse>) => {
    return response?.data;
}
const getError = (response?: SWRResponse<ReportGetSingleByIdResponse, ReportGetSingleByIdResponse>) => (response?.error ?? response?.data)?.responseStatus;
// const getAdditionalState = (response?: SWRResponse<StageGetSummaryCollectionByProjectIdResponse, StageGetSummaryCollectionByProjectIdResponse>) => ({});

const useReportById = (reportId?: number, configuration?: SWRConfiguration<ReportGetSingleByIdResponse, ReportGetSingleByIdResponse>) => {
    const request = useMemo(() => {
        if(!reportId) return undefined;
        return () => {
            return new ReportGetSingleById({
                reportId: reportId
            });
        };
    }, [reportId])

    return useGet(request, { getData, getError }, configuration);
}

export default useReportById;